module.exports = __webpack_public_path__ + "img/delivery0822.eb6295f5.png";